// removed by extract-text-webpack-plugin
module.exports = {"NewConversationButton":"NewConversationButton__1ZOxi","NewConversationWrapper":"NewConversationWrapper__K33Si","NewConversationText":"NewConversationText__hIZpd"};


//////////////////
// WEBPACK FOOTER
// ./routes/Conversations/NewConversationButton/style.scss
// module id = EOpn
// module chunks = 0